import EventBus from '../../utils/eventBus';

export class DrillDownNavigation {

    public readonly ACTIVE_CLASS: string = 'active';
    public readonly NAVIGATION_ID: string = 'responsive-navigation';
    public readonly ALL_LIST_ITEMS_SELECTOR: string = '.navigation-root li';
    public readonly ACTIVE_LEVEL_LIST_SELECTOR: string = 'ul.active';
    public readonly NAVIGATION_WRAPPER_SELECTOR: string = '.navigation-wrapper';

    private navigationElement: HTMLElement;
    private eventBus: EventBus;
    private menuOpen: boolean = false;
    private backButton: HTMLElement;
    private readonly header: HTMLElement;
    private readonly myLouisLink: HTMLElement;
    private readonly contactLink: HTMLElement;

    constructor(navigationElement: HTMLElement, eventBus: EventBus) {
        this.navigationElement = navigationElement;
        this.eventBus = eventBus;

        this.resetNavigationState();

        this.header = document.querySelector('header');
        if (!this.header) {
            return;
        }
        this.myLouisLink = this.header.querySelector('.main-nav-item-login a');
        this.contactLink = this.header.querySelector('.header-contact');
    }

    public activate = (): void => {
        this.addEventListener();
        this.addBackButton();

        const backButtonNeeded: boolean = this.navigationElement.querySelectorAll(this.ACTIVE_LEVEL_LIST_SELECTOR).length >= 1;
        if (backButtonNeeded) {
            this.activateBackButton();
        }

        if (!this.menuOpen) {
            return;
        }
        this.toggleHeaderElementsClasses(true);
    }

    public deactivate = (): void => {
        this.removeEventListener();
        this.removeBackButton();

        if (!this.menuOpen) {
            return;
        }
        this.toggleHeaderElementsClasses(false);
    }

    private activateBackButton = (): void => {
        if (!this.backButton) {
            return;
        }
        this.backButton.classList.add(this.ACTIVE_CLASS);
    }

    private deactivateBackButton = (): void => {
        if (!this.backButton) {
            return;
        }
        this.backButton.classList.remove(this.ACTIVE_CLASS);
    }

    private removeEventListener = (): void => {
        this.navigationElement.querySelectorAll(this.ALL_LIST_ITEMS_SELECTOR).forEach((el: HTMLElement) => el.onclick = undefined);
    }

    private addEventListener = (): void => {
        const navigationToggle: HTMLElement = document.querySelector(`[data-toggle="${this.NAVIGATION_ID}"]`);
        if (navigationToggle) {
            navigationToggle.addEventListener('click', this.toggleNavigation);
        }

        this.navigationElement.querySelectorAll(this.ALL_LIST_ITEMS_SELECTOR).forEach((element: HTMLElement) => {
            element.addEventListener('click', this.getShowNextLevelHandler(element));
        });
    }

    private getShowNextLevelHandler = (element: HTMLElement): (ev: MouseEvent) => void =>
        (e: MouseEvent): void => {
            if (element.classList.contains('has-children')) {
                e.preventDefault();
                const nextLevel: HTMLElement = element.querySelector('ul');
                nextLevel.classList.add(this.ACTIVE_CLASS);
                this.navigationElement.querySelector(this.NAVIGATION_WRAPPER_SELECTOR).scrollTop = 0;
                this.activateBackButton()
            }
            e.stopPropagation();
        }

    private toggleNavigation = (): void => {
        this.menuOpen = !this.menuOpen;
        this.toggleHeaderElementsClasses(this.menuOpen);
        if (this.menuOpen) {
            return;
        }
        this.resetNavigationState();
    };

    private resetNavigationState = (): void => {
        this.navigationElement.querySelectorAll(`.${this.ACTIVE_CLASS}`)
            .forEach((element: HTMLElement) => element.classList.remove(this.ACTIVE_CLASS));
        this.addBackButton();
        this.deactivateBackButton();
    }

    private addBackButton = (): void => {
        if (this.backButton) {
            return;
        }

        const firstChild = this.navigationElement.firstChild;
        const backButton: HTMLElement = document.createElement('button');
        backButton.classList.add('navi-back-button');
        const icon: HTMLElement = document.createElement('i');
        icon.className = ('header-icon icon icon-chevron-thin-left');
        backButton.append(icon);

        this.backButton = this.navigationElement.insertBefore(backButton, firstChild);

        this.backButton.onclick = this.handleBackButtonClick();
    }

    private removeBackButton = (): void => {
        if (!this.backButton) {
            return;
        }
        this.backButton.remove();
        this.backButton = null;
    }

    private handleBackButtonClick = (): (e: MouseEvent) => void =>
        (e: MouseEvent): void => {
            const activeLevelLists: NodeListOf<HTMLElement> = this.navigationElement.querySelectorAll(this.ACTIVE_LEVEL_LIST_SELECTOR);
            const lastActiveLevelList: HTMLElement = activeLevelLists[activeLevelLists.length - 1];
            if (!lastActiveLevelList) {
                return;
            }
            this.navigationElement.querySelector(this.NAVIGATION_WRAPPER_SELECTOR).scrollTop = 0;
            lastActiveLevelList.classList.remove(this.ACTIVE_CLASS);
            if (activeLevelLists.length === 1) {
                this.deactivateBackButton();
            }
            e.stopPropagation();
        };

    private toggleHeaderElementsClasses = (state: boolean): void => {
        this.addClassesToElement(this.header, ['responsive-navigation-open'], state);
        this.addClassesToElement(this.myLouisLink, ['button', 'button-red'], state);
        this.addClassesToElement(this.contactLink, ['button', 'button-grey'], state);
    }

    private addClassesToElement = (element: HTMLElement, cssClasses: string[], state: boolean): void => {
        if (!element) {
            return;
        }
        cssClasses.forEach((cssClass: string): void => state ? element.classList.add(cssClass) : element.classList.remove(cssClass));
    }
}

export default class DrillDownNavigationHandler {
    public static create = (navigationElement: HTMLElement, eventBus: EventBus): DrillDownNavigation => new DrillDownNavigation(navigationElement, eventBus)
}
